import { initTRPC, TRPCError } from "@trpc/server";
import { Context } from "./context"
import superjson from "superjson"

const t = initTRPC.context<Context>().create({
    transformer: superjson,
})

export const createTRPCRouter = t.router;
export const publicProcedure = t.procedure;

const userAuthValidation = t.middleware(({ ctx, next }) => {
    if (!ctx.contextUser) {
        throw new TRPCError({
            code: "UNAUTHORIZED",
            message: "Please log out and log back in to continue.",
        });
    }

    return next({
        ctx: {
            user: {
                ...ctx.contextUser,
            },
        },
    });
})

export const protectedProcedure = t.procedure.use(userAuthValidation)
